import React, { useMemo, useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage } from "react-intl";
import Copy from "copy-to-clipboard";
import Toast from "../../../../../../../components/toast";
import moment from "moment";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { useIntl } from "react-intl";
import { useQuery } from "../../../../../../../hooks/common";


const TrackingMessageSub = props =>{
    const { trackingMessage, isActive } = props;

    const locationMessage = useMemo(() =>{
        if(trackingMessage?.location){
            return `【${trackingMessage.location}】`;
        }
    }, [trackingMessage]);

    return <div className={`${cls.TrackingMessageSub} ${isActive ? cls.Active : ''}`}>
        <div className={cls.Time}>
            <p>{moment(trackingMessage?.checkpointTime).format('DD/MM')}</p>
            <p>{moment(trackingMessage?.checkpointTime).format('hh:mm:ss')}</p>
        </div>
        <div className={cls.Message}>
            <Iconfont className={`${cls.Icon}`}>&#xe63a;</Iconfont>

            <div className={cls.Font}>
                <p>{locationMessage}</p>
                <p>{trackingMessage?.message}</p>
            </div>
        </div>
    </div>
}

const TrackingMessageTotal = props =>{
    const { parcelPackage } = props;

    const trackings = useMemo(() =>{
        let arr = [];
        if(parcelPackage?.originPoints?.length > 0){
            arr = [...arr, ...parcelPackage.originPoints.reverse()];
        }

        if(parcelPackage?.destinPoints?.length > 0){
            arr = [...arr, ...parcelPackage.destinPoints.reverse()]
        }
        return arr;
    }, [parcelPackage]);
    
    return <div className={cls.TrackingMessageTotal}>
        <div className={cls.TrackingMessageList}>
            {
                trackings?.map((track, index) =>(
                    <TrackingMessageSub key={index+track?.checkpointTime} trackingMessage={track} isActive={index===0} />
                ))
            }
        </div>
    </div>
}

const ShippingFromMessage = props =>{
    const { parcelPackage, isSub } = props;
    const Intl = useIntl();
    const query = useQuery();

    const copyHandle = useCallback((id) =>{
        if(Copy(id)){
            Toast(Intl.formatMessage({ id: "copy_success", defaultMessage: "Copy successful" }));
        }else{
            Toast(Intl.formatMessage({ id: "copy_fail", defaultMessage: "copy failed! try again" }));
        }
    }, []);

    return <div className={cls.ShippingFromMessage}>
        {
            (parcelPackage.shipFromMsg || (isSub && query?.shipmsg)) && <div className={cls.Title}>{parcelPackage.shipFromMsg || query?.shipmsg}</div>
        }

        {
            parcelPackage.slug &&  <div className={cls.MessageCon}>
                <div className={cls.Left}>
                    <FormattedMessage id="logisticsCompany" defaultMessage="Logistics Company" />
                </div>

                <div className={cls.Right}>
                    {parcelPackage.slug}
                </div>
            </div>
        }
       
        {
            parcelPackage.trackingNumber && <div className={cls.MessageCon}>
                <div className={cls.Left}>
                    <FormattedMessage id="tracknum" defaultMessage="Tracking Number" />
                </div>

                <div className={cls.Right}>
                    <span>{parcelPackage.trackingNumber}</span>
                    <Iconfont className={cls.Icon} onClick={() =>copyHandle(parcelPackage.trackingNumber)}>&#xe776;</Iconfont>
                </div>
            </div>
        }
        
        {
            parcelPackage.logisticsSupplierWebsiteURL && <div className={cls.DetailInfo}>
                <div className={cls.Name}><FormattedMessage id="trackingDetailInfo" defaultMessage="Tracking Detail Information" /></div>

                <div className={cls.Content}>
                    <a style={{textDecoration: 'underline', color: '#0000EE'}}>{parcelPackage?.logisticsSupplierWebsiteURL}</a>
                </div>
            </div>
        }
        
    </div>
}

const TrackingStatus = props =>{
    const { status } = props;
    const query = useQuery();

    const iconDom = useCallback((type) =>{
        if(type === '1'){
            return <Iconfont>&#xe6a9;</Iconfont>; 
        }else if(type === '6'){
            return <Iconfont>&#xe6a7;</Iconfont>;
        }else{
            return <Iconfont>&#xe6a5;</Iconfont>;
        }
    }, []);

    return <div className={cls.TrackingStatus}>
        <div className={cls.Container}>
            <div className={cls.Icon}>
                {iconDom(query?.type)}
            </div>

            <div className={cls.Font}>
                <span><FormattedMessage id="currentStatus" defaultMessage="Current Stataus" />:</span>
                <span>{status}</span>
            </div>
        </div>
    </div>
}

const PackageTracing = props =>{
    useStyles(cls);
    const { parcelPackage, isSub } = props;

    return <div className={cls.PackageTracing}>
        <ShippingFromMessage parcelPackage={parcelPackage} isSub={isSub} />
        
        {
            (parcelPackage?.trackingStatusView || parcelPackage?.statusView) && <TrackingStatus status={parcelPackage.trackingStatusView || parcelPackage?.statusView} />
        }
        
        <TrackingMessageTotal parcelPackage={parcelPackage} />
    </div>
}

export default PackageTracing;